
(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', function () {
        initHeroSlider();
        initLangSwitcher();
        initMobileNav();
        initHeaderScroll();
    });

    function initHeaderScroll() {
        const header = document.querySelector('.site-header');
        if (!header) return;

        const threshold = 40;
        let ticking = false;

        function update() {
            const scrolled = window.scrollY > threshold;
            header.classList.toggle('is-scrolled', scrolled);
            ticking = false;
        }

        window.addEventListener('scroll', function () {
            if (!ticking) {
                window.requestAnimationFrame(update);
                ticking = true;
            }
        }, { passive: true });

        update();
    }

    function initMobileNav() {
        const nav       = document.querySelector('[data-mobile-nav]');
        const toggle    = document.querySelector('[data-mobile-nav-toggle]');
        const closers   = document.querySelectorAll('[data-mobile-nav-close]');
        if (!nav || !toggle) return;

        const drawer   = nav.querySelector('.mobile-nav__drawer');
        let lastFocus  = null;

        function getFocusable() {
            return drawer.querySelectorAll(
                'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
            );
        }

        function open() {
            lastFocus = document.activeElement;
            nav.classList.add('is-open');
            nav.setAttribute('aria-hidden', 'false');
            toggle.setAttribute('aria-expanded', 'true');
            document.body.classList.add('is-mobile-nav-open');
            setTimeout(function () {
                const f = getFocusable();
                if (f.length) f[0].focus();
            }, 100);
        }

        function close() {
            nav.classList.remove('is-open');
            nav.setAttribute('aria-hidden', 'true');
            toggle.setAttribute('aria-expanded', 'false');
            document.body.classList.remove('is-mobile-nav-open');
            if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
        }

        toggle.addEventListener('click', function () {
            if (nav.classList.contains('is-open')) close(); else open();
        });

        closers.forEach(function (el) {
            el.addEventListener('click', close);
        });

        document.addEventListener('keydown', function (e) {
            if (!nav.classList.contains('is-open')) return;

            if (e.key === 'Escape') { e.preventDefault(); close(); return; }

            if (e.key === 'Tab') {
                const f = getFocusable();
                if (!f.length) return;
                const first = f[0];
                const last  = f[f.length - 1];
                if (e.shiftKey && document.activeElement === first) {
                    e.preventDefault(); last.focus();
                } else if (!e.shiftKey && document.activeElement === last) {
                    e.preventDefault(); first.focus();
                }
            }
        });

        drawer.querySelectorAll('a[href]').forEach(function (a) {
            a.addEventListener('click', function () {
                if (a.getAttribute('href').startsWith('#')) close();
            });
        });
    }

    function initLangSwitcher() {
        document.querySelectorAll('[data-lang-switcher]').forEach(function (wrap) {
            const btn = wrap.querySelector('.site-header__lang-btn');
            if (!btn) return;

            function open() {
                wrap.classList.add('is-open');
                btn.setAttribute('aria-expanded', 'true');
            }
            function close() {
                wrap.classList.remove('is-open');
                btn.setAttribute('aria-expanded', 'false');
            }
            function toggle() {
                if (wrap.classList.contains('is-open')) close(); else open();
            }

            btn.addEventListener('click', function (e) {
                e.stopPropagation();
                toggle();
            });

            document.addEventListener('click', function (e) {
                if (!wrap.contains(e.target)) close();
            });

            document.addEventListener('keydown', function (e) {
                if (e.key === 'Escape') close();
            });
        });
    }

    function initHeroSlider() {
        document.querySelectorAll('[data-hero-slider]').forEach(wrap => {
            const slides = Array.from(wrap.querySelectorAll('[data-slide-index]'));
            const dots   = Array.from(wrap.querySelectorAll('[data-slider-dot]'));
            const total  = Math.max(slides.length, dots.length);
            if (total < 2) return;

            let current  = 0;
            let timerId  = null;
            const autoplay = parseInt(wrap.dataset.autoplay, 10) || 0;

            function go(i) {
                current = (i + total) % total;
                slides.forEach((s, idx) => {
                    const active = idx === current;
                    s.classList.toggle('is-active', active);
                    s.setAttribute('aria-hidden', active ? 'false' : 'true');
                });
                dots.forEach((d, idx) => {
                    const active = idx === current;
                    d.classList.toggle('is-active', active);
                    d.setAttribute('aria-selected', active ? 'true' : 'false');
                });
            }

            function start() {
                if (autoplay > 0 && !timerId) {
                    timerId = setInterval(() => go(current + 1), autoplay);
                }
            }
            function stop() {
                if (timerId) { clearInterval(timerId); timerId = null; }
            }

            dots.forEach((dot, idx) => dot.addEventListener('click', () => {
                go(idx);
                stop(); start();
            }));

            wrap.addEventListener('mouseenter', stop);
            wrap.addEventListener('mouseleave', start);
            wrap.addEventListener('focusin',   stop);
            wrap.addEventListener('focusout',  start);

            start();
        });
    }

})();
